import React from "react";
import "./spinner.css";
//import "../Loader3/spinner.css";

export default function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}
